import React from "react";
import {
  Button,
  CircularProgress,
  FormControl,
  InputAdornment,
  OutlinedInput,
  styled,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export interface SearchFieldProps {
  /** The data attribute used for targeting this component in Cypress */
  "data-cy"?: string;
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  onClick?: React.MouseEventHandler;
  loading?: boolean;
  placeholder?: string;
}

/** A combined search input */
export const SearchField = ({
  "data-cy": dataCy,
  value,
  onChange,
  onClick,
  loading,
  placeholder = "What are you looking for?",
}: SearchFieldProps) => {
  // Note: label prop doesn't do the animation thing when combined with startAdornment
  // Hence placeholder used here.
  return (
    <Root>
      <FormControl fullWidth>
        {/* <InputLabel htmlFor="standard-adornment-amount">*/}
        {/*  What are you looking for?*/}
        {/* </InputLabel>*/}
        <OutlinedInput
          placeholder={placeholder}
          id="standard-adornment-amount"
          value={value}
          onChange={onChange}
          // labelWidth={172}
          sx={getStyles.inputRoot}
          startAdornment={
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          }
        />
      </FormControl>
      <Button
        variant="contained"
        color="primary"
        sx={getStyles.go}
        onClick={onClick}
        disabled={loading}
      >
        {loading ? <CircularProgress color="inherit" size="1rem" /> : "Go"}
      </Button>
    </Root>
  );
};

const Root = styled("div")({
  display: "flex",
});

const getStyles = {
  inputRoot: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  go: {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
};
